import gsap from 'gsap'

function staffList() {
    const staffList = document.querySelector('[data-target="staff-list"]')

    if (staffList) {
        /**
         *  ACTIVE BG
         */
        function activeBg() {
            const staffListItems = staffList.querySelectorAll(
                '[data-target="staff-list-item"]'
            )
            const staffContainers = staffList.querySelectorAll('[data-team]')
            const activeBg = staffList.querySelector(
                '[data-target="active-bg"]'
            )
            let activeContainer = document.querySelector('.active-container')
            let activeItem = staffList.querySelector('.active-team')
            let itemWidth = activeItem.offsetWidth
            let itemPosX = activeItem.offsetLeft
            let itemPosY = activeItem.offsetTop

            gsap.set(activeBg, {
                left: itemPosX,
                width: itemWidth,
            })

            staffListItems.forEach((item, index) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault()

                    activeContainer =
                        document.querySelector('.active-container')
                    activeItem = staffList.querySelector('.active-team')
                    itemWidth = item.offsetWidth
                    itemPosX = item.offsetLeft
                    itemPosY = item.offsetTop

                    activeItem.classList.remove('active-team')
                    item.classList.add('active-team')

                    activeContainer.classList.remove('active-container')
                    staffContainers[index].classList.add('active-container')

                    staffContainers.forEach((container) => {
                        if (!container.classList.contains('active-container')) {
                            gsap.to(container, {
                                autoAlpha: 0,
                                // delay: 0.25,
                                duration: 0.85,
                                position: 'absolute',
                            })
                        } else {
                            gsap.to(container, {
                                autoAlpha: 1,
                                duration: 0.85,
                                position: 'relative',
                            })
                        }
                    })

                    if (window.innerWidth < 1024) {
                        gsap.to(activeBg, {
                            duration: 0.3,
                            top: itemPosY,
                            left: itemPosX,
                            width: itemWidth,
                            ease: 'power2.inOut',
                        })
                    } else {
                        gsap.to(activeBg, {
                            duration: 0.3,
                            left: itemPosX,
                            width: itemWidth,
                            ease: 'power2.inOut',
                        })
                    }
                })
            })
        }

        /**
         *  POPUPS
         */

        function initStaffPopups() {
            const popups = document.querySelectorAll(
                '[data-target="popup-staff"]'
            )
            const hasPopup = document.querySelectorAll(
                '[data-target="has-staff-popup"]'
            )

            hasPopup.forEach((link, index) => {
                const popupOverlay = document.querySelectorAll(
                    '[data-target="overlay"]'
                )
                const popupContent = document.querySelectorAll(
                    '[data-target="popup-content"]'
                )
                const href = link.querySelector('a')
                const hrefID = href.getAttribute('href')
                const closeBtn = document.querySelectorAll(
                    '[data-target="close-button"]'
                )

                href.addEventListener('click', (e) => {
                    e.preventDefault()
                })

                gsap.set(popupOverlay, { autoAlpha: 0 })
                gsap.set(popupContent, { autoAlpha: 0, xPercent: 100 })
                gsap.set(popups, { pointerEvents: 'none' })

                link.addEventListener('click', (e) => {
                    document.documentElement.style.overflow = 'hidden'

                    gsap.to(hrefID, {
                        autoAlpha: 1,
                        duration: 0.3,
                    })
                    gsap.to(popupOverlay[index], {
                        autoAlpha: 1,
                        xPercent: 0,
                        duration: 0.3,
                    })
                    gsap.to(popupContent[index], {
                        autoAlpha: 1,
                        xPercent: 0,
                        duration: 0.3,
                    })
                    gsap.set(popups[index], { pointerEvents: 'all' })
                })

                popupOverlay[index].addEventListener(
                    'click',
                    (e) => {
                        document.documentElement.style.overflow = 'auto'

                        gsap.to(hrefID, {
                            autoAlpha: 0,
                            duration: 0.3,
                        })
                        gsap.to(popupContent[index], {
                            autoAlpha: 0,
                            xPercent: 100,
                            duration: 0.3,
                        })
                        gsap.set(popups, { pointerEvents: 'none' })
                    },
                    false
                )

                closeBtn.forEach((btn) => {
                    btn.addEventListener(
                        'click',
                        (e) => {
                            document.documentElement.style.overflow = 'auto'

                            gsap.to(hrefID, {
                                autoAlpha: 0,
                                duration: 0.3,
                            })
                            gsap.to(popupContent[index], {
                                autoAlpha: 0,
                                xPercent: 100,
                                duration: 0.3,
                            })
                            gsap.set(popups, { pointerEvents: 'none' })
                        },
                        false
                    )
                })
            })
        }

        initStaffPopups()
        activeBg()
    }
}

export default staffList
